// extracted by mini-css-extract-plugin
module.exports = {"csvText":"DownloadCsvButton_csvText__1rr1_","spinContainer":"DownloadCsvButton_spinContainer__cRsav"};